<template>
  <router-link
    class="TreeNodeLink"
    :class="cc"
    :to="{params: {actor: actor.pathArr}, query: $route.query}"
  >
    {{ actor.name }}
  </router-link>
</template>

<script>
export default {
  name: 'TreeNodeLink',
  props: {
    actor: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    },
    level: {
      type: Number,
      required: true
    }
  },
  computed: {
    cc() {
      const color = this.actor.color
      return [
        `before:text-${color}`,
        this.active ? `text-${color}` : 'text-gray-900',
        this.selected ? `before:bg-${color}` : 'bg-gray-100',
        `hover:text-${color} hover:before:bg-${color}`
      ]
    }
  }
}
</script>

<style scoped>
.TreeNodeLink {
  @apply inline-flex font-mono text-s;
  line-height: 16px;
  margin-right: 16px;
  &:before {
    content: '';
    border: 2px solid;
    @apply flex-none w-4 h-4 mr-3 rounded-full;
  }
}
</style>
